import { useMutation } from 'react-query';

import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

export type ValidateMobileTokenProps = {
  hash: string;
  phone: string;
  token: string;
};

export type ValidateMobileTokenResponseProps = {
  id: null;
  groupId: null;
  phone: string;
  lang: string;
  tries: number;
  deliveries: number;
  validAt: string;
  usedAt: null;
  createdAt: null;
};

export const validateMobileToken = ({
  hash,
  phone,
  token,
}: ValidateMobileTokenProps): Promise<ValidateMobileTokenResponseProps> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'mobile-token/validate';

  return axios
    .post(
      endPoint,
      {
        hash,
        phone,
        token,
      },
      {
        validateStatus: (status) => status < 500,
      }
    )
    .then((response: any) => {
      if (typeof response === 'string') {
        throw Error(`Critical error fetching data in ${endPoint}`);
      }

      return response;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};

type UseValidateMobileToken = {
  config?: MutationConfig<typeof validateMobileToken>;
};

export const useValidateMobileToken = ({ config }: UseValidateMobileToken = {}) => {
  return useMutation({
    onMutate: async (creatingNotification: any) => {
      await queryClient.cancelQueries(['mobile-token', creatingNotification]);

      const previousDetails = queryClient.getQueryData<ValidateMobileTokenProps>([
        'mobile-token',
        creatingNotification,
      ]);

      queryClient.setQueryData(['mobile-token', creatingNotification], {
        ...previousDetails,
        ...creatingNotification.data,
      });

      return { previousDetails: previousDetails };
    },

    onError: (_, __, context: any) => {
      if (context?.previousDetails) {
        queryClient.setQueryData(
          ['mobile-token', context.previousDetails],
          context.previousDetails
        );
      }
    },

    onSuccess: (data) => {
      queryClient.refetchQueries(['mobile-token', data]);
    },
    ...config,

    mutationFn: validateMobileToken,
  });
};
